import type { ButtonHTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

import { useStyles } from './styles';

export type PillButtonVariant =
  | 'brand'
  | 'danger'
  | 'secondary'
  | 'tertiary'
  | 'text'
  | 'positive'
  | 'dangerText';

interface PillButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: PillButtonVariant;
  /** tighter horizontal padding, for actions inside table rows */
  compact?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
}

/**
 * The one button PDV uses: a 40px pill in the prototype's variants. A native
 * button, so it inherits nothing from MUI's Button theme.
 */
export const PillButton = ({
  variant = 'tertiary',
  compact,
  startIcon,
  endIcon,
  className,
  children,
  type = 'button',
  ...rest
}: PillButtonProps) => {
  const classes = useStyles();
  const solid = variant === 'brand' || variant === 'danger';

  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={type}
      className={clsx(
        classes.root,
        classes[variant],
        solid && classes.solidDisabled,
        compact && classes.compact,
        className
      )}
      {...rest}>
      {startIcon}
      {children}
      {endIcon}
    </button>
  );
};
